export function handleMediaDownloadVideoPlayback() {
    const downloadMediaVideosEl = document.querySelectorAll(".pul-download-card--video");
    const videos = document.querySelectorAll(".pul-download-card--video video");
    
    if (downloadMediaVideosEl.length > 0) {
        for (const downloadMediaVideoEl of downloadMediaVideosEl) {
            const video = downloadMediaVideoEl.querySelector("video");
            const playBtn = downloadMediaVideoEl.querySelector(".pul-download-card__media-play");

            playBtn.addEventListener("click", () => {
                // pause curretnly playing video
                videos.forEach(video => {
                    video.pause();
                    video.removeAttribute("controls");
                    video.nextElementSibling.classList.remove("playing");
                });

                // play current video
                video.setAttribute("controls", "");
                video.play();
                playBtn.classList.add("playing");
            });

            video.addEventListener("ended", () => {
                // remove controls from video
                video.removeAttribute("controls");
                playBtn.classList.remove("playing");
            });

            video.addEventListener("click", () => {
                // remove controls from video
                video.removeAttribute("controls");
                video.pause();
                playBtn.classList.remove("playing");
            });
        }
    }
}